'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createResource = undefined;

var _reactCache = require('react-cache');

var createResource = void 0;

if (_reactCache.unstable_createResource) {
  exports.createResource = createResource = _reactCache.unstable_createResource;
}

exports.createResource = createResource;